import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { environment } from '../../../environments/environment';
import { ToastService } from '../toast/toast.service';

@Component({
    selector: 'app-payment-cancel',
    templateUrl: './payment-cancel.component.html',
})
export class PaymentCancelComponent {
    working = false;
    userToken: string;

    constructor(public modal: NgbActiveModal, private http: HttpClient, private toastService: ToastService) {}

    cancel() {
        this.working = true;

        this.http.delete(`${environment.api}/v1/subscriptions?token=${this.userToken}`).subscribe(
            () => {
                this.toastService.show('Your subscription has been successfully cancelled.', {
                    classname: 'ngbd-toast-closeable bg-success text-light',
                    header: 'Success',
                });
                this.modal.dismiss('success');
            },
            () => {
                this.toastService.show(
                    `There was an unexpected server error. Your subscription was not cancelled,
                     please contact support if this error persists.`,
                    { classname: 'ngbd-toast-closeable bg-danger text-light', header: 'Error' },
                );
                this.modal.dismiss('error');
            },
        );
    }
}
